import { useMemo } from 'react';

import {
  detectClient,
  KELIRIJI_DOWNLOAD_URL,
  matchedTileId,
  parseStoreKey,
} from '../data/kelirijiDownload';
import { StoreTiles } from './StoreTiles';

type DownloadQrBlockProps = {
  tone?: 'light' | 'dark';
};

export function DownloadQrBlock({ tone = 'light' }: DownloadQrBlockProps) {
  const dark = tone === 'dark';
  const label = dark ? 'text-[#F0F5FF]' : 'text-ink';
  const mute = dark ? 'text-[#8A9CB8]' : 'text-muted';
  const client = useMemo(() => {
    if (typeof navigator === 'undefined') return detectClient('');
    return detectClient(navigator.userAgent, {
      platform: navigator.platform,
      maxTouchPoints: navigator.maxTouchPoints,
    });
  }, []);
  const forcedStore = useMemo(() => {
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(window.location.search);
    return parseStoreKey(params.get('store') || params.get('channel') || params.get('market'));
  }, []);
  const activeId = matchedTileId(client, forcedStore);

  return (
    <section
      className={
        dark
          ? 'rounded-2xl border border-white/12 bg-white/[0.06] px-5 py-6'
          : 'rounded-2xl border border-border bg-surface px-5 py-6'
      }
    >
      <p className={`text-sm font-semibold ${label}`}>下载颗粒日记 App</p>
      <div className="mt-5 flex flex-col items-center gap-5 sm:flex-row sm:items-center">
        <img
          src="/qr-download.png"
          alt="颗粒日记下载二维码，长按识别下载"
          width={220}
          height={220}
          className="h-48 w-48 rounded-2xl bg-white p-2 sm:h-52 sm:w-52"
        />
        <div className="min-w-0 w-full text-center sm:text-left">
          <p className={`text-xs leading-5 ${mute}`}>长按二维码 · 识别或保存</p>
          <p className={`mt-1 break-all font-mono text-[11px] ${dark ? 'text-[#A8B8CC]' : 'text-ink'}`}>
            {KELIRIJI_DOWNLOAD_URL}
          </p>
        </div>
      </div>
      <div className="mt-5">
        <StoreTiles tone={tone} activeId={activeId} />
      </div>
    </section>
  );
}
